module.exports = __webpack_public_path__ + "img/img_influencer.3f174160.png";